export const Radii = {
  none: "0px",
  xxs: "2px",
  xs: "4px",
  sm: "6px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  xxl: "20px",
  "2xl": "24px",
  full: "9999px",
} as const;

export type Radius = typeof Radii;
